import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchRelationship, DataState, ClergyBioRoutes } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ClericIcon } from '../../account-info/components/cleric-indicator';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';
import { getFormattedDate, getMaskedDate } from '../../../global/helpers/date-helpers';

interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioRelationshipsReview(props: Props) {

	const { settings, basePath } = props;
	const headerClasses = headerIconStyles();
	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.relationship);
	const relationships = useSelector<TcsmStates, ClergyBioChurchRelationship>(state => state?.clergyBioState?.relationship);
	const currentSpouse = relationships?.currentSpouse?.details[0];
	const buttonClasses = buttonStyles();

	function RenderSectionDefaultMessage(defaultMessage) {
		if (!defaultMessage) return null;

		return (
			<ContentSpacer>
				<WysiwygWithReactLink content={defaultMessage} />
			</ContentSpacer>
		);
	}

	function RenderContent() {
		return (
			<>
				<div>

					<h3>{settings?.parentLabel}</h3>
					{
						relationships?.parents?.details?.length > 0 ?
							relationships?.parents?.details?.map(p =>
								<div key={p?.id} >
									<ContentSpacer>
										<div className={headerClasses.iconHeader}>
											<ClericIcon />
											<p><strong>{`${p?.firstName} ${p?.middleName} ${p?.lastName}`}</strong></p>
										</div>
										<p>{p?.gender}</p>
										{
											p?.dob && <p className='grey-caption'>{settings?.dateOfBirthLabel}: {getMaskedDate(getFormattedDate(p?.dob), 2)}</p>
										}
									</ContentSpacer>
								</div>,
							) : RenderSectionDefaultMessage(settings?.noParentsDescription)
					}
				</div>

				<div>
					<h3>{settings?.currentSpouseLabel}</h3>
					{
						currentSpouse ?
							<>
								<ContentSpacer>
									<WysiwygWithReactLink content={settings?.currentSpouseDescription} />
								</ContentSpacer>
								<div className={headerClasses.iconHeader}>
									<ClericIcon />
									<p><strong>{currentSpouse?.firstName} {currentSpouse?.middleName} {currentSpouse?.lastName}</strong></p>
								</div>
								<p>{currentSpouse?.gender}</p>
								{
									currentSpouse?.dob && <p className='grey-caption'>{settings?.dateOfBirthLabel}: {getMaskedDate(getFormattedDate(currentSpouse?.dob), 2)}</p>
								}
								{
									currentSpouse?.dom && <p className='grey-caption'>{settings?.dateOfMarriageLabel}: {getFormattedDate(currentSpouse?.dom)}</p>
								}
							</> : RenderSectionDefaultMessage(settings?.noCurrentSpouseDescription)
					}
				</div>

				<div>

					<h3>{settings?.childrenTitle}</h3>
					{
						relationships?.children?.details?.length > 0 ?
							relationships?.children?.details?.map(p =>
								<div key={p?.id} >
									<ContentSpacer>
										<p><strong>{p?.firstName} {p?.middleName} {p?.lastName}</strong></p>
										<p>{p?.gender}</p>
										<p className='grey-caption'>{settings?.dateOfBirthLabel}: {getMaskedDate(getFormattedDate(p?.dob), 2)}</p>
									</ContentSpacer>
								</div>,
							) : RenderSectionDefaultMessage(settings?.noChildrenDescription)
					}
				</div>
			</>
		);
	}

	return (
		<DividerSection sectionText={settings?.relationshipTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={RenderContent()}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.Relationships}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioRelationshipsReview;